import React from 'react';
import Modal from '../../../modal/modal';
import { Translations } from '../mapbox-with-service-areas';

interface Props {
	visible: boolean;
	onDelete: () => void;
	onCancel: () => void;
	translations: Translations;
}

const DeleteServiceAreaModal: React.FC<Props> = props => {
	const { visible, onDelete, onCancel, translations } = props;

	return (
		<Modal
			className="mapbox-with-service-areas-modal"
			visible={visible}
			onOk={onDelete}
			onCancel={onCancel}
			footer={
				<div className="modal-footer">
					<button type="button" className="modal-footer-button modal-footer-button-cancel" onClick={onCancel}>
						{translations.cancel}
					</button>
					<button
						type="button"
						className="modal-footer-button modal-footer-button-save"
						data-dismiss="modal"
						onClick={onDelete}
					>
						{translations.delete}
					</button>
				</div>
			}
		>
			<span className="mapbox-with-service-areas-modal-title">{translations.deleteAreaTitle}</span>
		</Modal>
	);
};

export default DeleteServiceAreaModal;
